import service from '@/utils/https'

export const login = async (credentials) => {
  const response = await service.post('/api/app/v1/auth/login', credentials, {
    hideMessageModal: true,
  })
  const payload = response.data

  if (payload.code !== 200 || !payload.data?.session) {
    throw new Error(payload.message || 'Authentication failed')
  }

  const { session } = payload.data
  const user = session.user

  return {
    user: {
      ...user,
      role: session.role || user?.role || 'freelancer',
    },
    role: session.role || user?.role || 'freelancer',
    permissions: session.permissions ?? [],
    session,
    code: payload.code,
    message: payload.message,
  }
}

export const register = async () => {
  throw new Error('Use apiRegister instead of register()')
}

export const forgotPassword = async (email) => {
  const response = await service.post('/api/app/v1/auth/forgot-password', { email })
  const payload = response.data

  if (payload.code !== 200) {
    throw new Error(payload.message || 'Failed to send password reset email')
  }

  return {
    message: payload.message || 'Password reset email sent successfully',
  }
}

export const resetPassword = async (resetData) => {
  const response = await service.post('/api/app/v1/auth/reset-password', {
    password: resetData.password,
  }, {
    hideMessageModal: true,
  })
  const payload = response.data

  if (payload.code !== 200) {
    throw new Error(payload.message || 'Failed to reset password')
  }

  return {
    message: payload.message || 'Password reset successfully',
  }
}

export const bootstrapRecoverySession = async (params) => {
  const body = params.tokenHash
    ? { token_hash: params.tokenHash }
    : {
        access_token: params.accessToken,
        refresh_token: params.refreshToken,
      }

  const response = await service.post('/api/app/v1/auth/recovery/bootstrap', body, {
    hideMessageModal: true,
  })
  const payload = response.data

  if (payload.code !== 200) {
    throw new Error(payload.message || 'Invalid recovery session')
  }

  return payload
}

export const fetchRecoveryStatus = async () => {
  const response = await service.get('/api/app/v1/auth/recovery/status', undefined, {
    hideMessageModal: true,
  })
  const payload = response.data

  if (payload.code !== 200) {
    return false
  }

  return Boolean(payload.data?.ready)
}

export const sendVerificationCode = async (email) => {
  const response = await service.post('/api/app/v1/auth/resend-verification', { email })
  const payload = response.data

  if (payload.code !== 200) {
    throw new Error(payload.message || 'Failed to resend verification email')
  }

  return {
    message: payload.message || 'Verification code sent successfully',
  }
}

export const validateInvitation = (token, config = {}) => {
  return service.post('/api/app/v1/auth/validate-invitation', { token }, config)
}

export const acceptFreelancerInvitation = (token, accept) => {
  return service.post('/api/app/v1/freelancers/accept-invitation', { token, accept })
}

export const apiRegister = async (params) => {
  const payload = {
    email: params.email,
    password: params.password,
    confirm_password: params.confirm_password,
    firstName: params.firstName,
    lastName: params.lastName,
    role: params.role,
    token: params.token,
    preferred_locale: params.preferred_locale,
  }

  const response = await service.post('/api/app/v1/auth/register', payload)
  return response.data
}

export { signInWithLinkedIn } from '@/lib/auth/linkedinOAuth'

export default {
  login,
  register,
  forgotPassword,
  resetPassword,
}
